var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "h3",
      { staticClass: "form-section", staticStyle: { "margin-top": "10px" } },
      [_vm._v("Multimedia")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _vm._l(_vm.actualMultimediaNumber, function(i, key) {
            return _c(
              "div",
              {
                key: key,
                staticClass: "row",
                attrs: { id: "multimedia_files" }
              },
              [
                _vm.multimedia[i - 1] != undefined
                  ? _c("div", { staticClass: "col-md-11 col-md-offset-1" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-3" }, [
                          _c("div", { staticClass: "text-center" }, [
                            _vm.multimedia[i - 1].uploaded &&
                            _vm.multimedia[i - 1].isImage
                              ? _c("img", {
                                  staticClass: "img-responsive img-thumbnail",
                                  staticStyle: { "max-height": "160px" },
                                  attrs: {
                                    src:
                                      _vm.multimediaTempDir +
                                      _vm.multimedia[i - 1].name
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.multimedia[i - 1].uploaded &&
                            _vm.multimedia[i - 1].isImage
                              ? _c("img", {
                                  staticClass: "img-responsive img-thumbnail",
                                  staticStyle: { "max-height": "160px" },
                                  attrs: {
                                    src:
                                      _vm.multimediaDir +
                                      _vm.multimedia[i - 1].name
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.multimedia[i - 1].uploaded &&
                            !_vm.multimedia[i - 1].isImage
                              ? _c("img", {
                                  staticClass: "img-responsive img-thumbnail",
                                  staticStyle: { "max-height": "160px" },
                                  attrs: { src: "/assets/image_default.png" }
                                })
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-9" }, [
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _vm._m(0, true),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-9" }, [
                                _c("input", {
                                  staticClass: "form-control",
                                  staticStyle: {
                                    border: "none",
                                    "margin-top": "-1px"
                                  },
                                  attrs: { type: "text", readonly: "" },
                                  domProps: {
                                    value: _vm.multimedia[i - 1].name
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  class:
                                    _vm.multimedia[i - 1].fileNameErrorClass
                                },
                                [
                                  _vm._m(1, true),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-md-9" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.multimedia[i - 1].fileName,
                                          expression:
                                            "multimedia[i - 1].fileName"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      attrs: {
                                        type: "text",
                                        disabled: _vm.blockingFieldEditing
                                      },
                                      domProps: {
                                        value: _vm.multimedia[i - 1].fileName
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.multimedia[i - 1],
                                            "fileName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "row",
                              staticStyle: { "margin-bottom": "5px" }
                            },
                            [
                              _vm._m(2, true),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-9" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.multimedia[i - 1].description,
                                      expression:
                                        "multimedia[i - 1].description"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.blockingFieldEditing
                                  },
                                  domProps: {
                                    value: _vm.multimedia[i - 1].description
                                  },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.multimedia[i - 1],
                                        "description",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { class: _vm.multimedia[i - 1].tagErrorClass },
                              [
                                _vm._m(3, true),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-md-9" },
                                  [
                                    _c("multiselect", {
                                      attrs: {
                                        checked:
                                          _vm.multimedia[i - 1].selectedTags,
                                        options: _vm.tags,
                                        label: "value",
                                        disabled: _vm.blockingFieldEditing
                                      },
                                      model: {
                                        value: _vm.multimedia[i - 1].tag,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.multimedia[i - 1],
                                            "tag",
                                            $$v
                                          )
                                        },
                                        expression: "multimedia[i - 1].tag"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.multimedia[i - 1].tagError
                                      ? _c(
                                          "span",
                                          { staticClass: "help-block" },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.multimedia[i - 1]
                                                      .tagError
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-12" }, [
                          _c("div", { staticClass: "text-right" }, [
                            !_vm.multimedia[i - 1].isTempUpload
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-info",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.downloadFile(
                                          _vm.multimedia[i - 1].name,
                                          false,
                                          false
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    Pobierz\n                                "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.multimedia[i - 1].isTempUpload
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-info",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.downloadFile(
                                          _vm.multimedia[i - 1].name,
                                          _vm.multimedia[i - 1].fileName,
                                          true
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                  Pobierz\n                                "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-danger",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.blockingFieldEditing
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeMultimedia(i - 1)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                  Usuń\n                                "
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    ])
                  : _vm._e()
              ]
            )
          }),
          _vm._v(" "),
          _c("div", { staticClass: "hidden" }, [
            _c("input", {
              attrs: { id: "mediaUploader", type: "file" },
              on: { change: _vm.uploadFile }
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-default",
              attrs: { type: "button", disabled: _vm.blockingFieldEditing },
              on: { click: _vm.uploadMultimedia }
            },
            [_vm._v("Dodaj plik...")]
          ),
          _vm._v(" "),
          _vm.errorText
            ? _c("span", { staticClass: "help-block" }, [
                _c("p", [_vm._v(" " + _vm._s(_vm.errorText) + " ")])
              ])
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", { staticClass: "control-label" }, [_vm._v("Plik")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", { staticClass: "control-label" }, [_vm._v("Nazwa pliku")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", { staticClass: "control-label" }, [_vm._v("Opis pliku")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-3" }, [
      _c("label", { staticClass: "control-label" }, [_vm._v("Tagi pliku")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d0a343c", { render: render, staticRenderFns: staticRenderFns })
  }
}